import { useQuery } from '@tanstack/react-query';
import { countMyCorrections, type CorrectionStatusCounts } from './api';

const NONE: CorrectionStatusCounts = { PENDING: 0, APPROVED: 0, REJECTED: 0 };

/**
 * Owner decision D8 — the reporter's own correction requests, by status.
 * The sidebar badge on "Solicitari corectare" and the Atentie section of Acasa
 * read the same cached fetch, one per page load, because the endpoint answers
 * with all three states at once.
 */
export function useMyCorrectionCounts(enabled: boolean): {
  counts: CorrectionStatusCounts;
  isLoading: boolean;
} {
  const q = useQuery({
    queryKey: ['my-correction-counts'],
    queryFn: countMyCorrections,
    enabled,
    staleTime: 15_000,
  });
  return { counts: q.data ?? NONE, isLoading: q.isLoading };
}
